<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">机构修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-row>
                    <el-col :span="24" class="item">
                        <div class="label">机构logo</div>
                        <el-upload
                        class="upload-demo"
                            :action="uploadUrl"
                            list-type="picture-card"
                            :data='uploadData'
                            :show-file-list="false"
                            :on-success="handleImgSuccess"
                            style="width:100%;">
                            <img v-if="editForm.logo" :src="editForm.logo" fit='cover'  class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">机构名称</div>
                        <el-input v-model="editForm.name"></el-input>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">固话</div>
                        <el-input v-model="editForm.tel"></el-input>
                    </el-col>
                </el-row>

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">联系人</div>
                        <el-input v-model="editForm.contacts"></el-input>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">地址</div>
                        <!-- <el-input v-model="editForm.address"></el-input> -->
                        <el-input v-model="editForm.address" disabled placeholder="请选择详细地址" class="homeAddress">
                            <el-button slot="append" icon="el-icon-search" @click="openBaiduMap">
                            选择
                            </el-button>
                        </el-input>
                    </el-col>
                </el-row>

                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">是否连锁</div>
                        <el-radio v-model="editForm.isChain" label='0'>否</el-radio>
                        <el-radio v-model="editForm.isChain" label='1'>是</el-radio>
                    </el-col>
                    <el-col :span="12" class="item">
                        <div class="label">连锁类型</div>
                        <el-select v-model="editForm.chainType"  @change="chainTypesChange" style="width: 100%">
                            <el-option
                                    v-for="item in chainTypes"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="12" class="item">
                        <div class="label">机构状态</div>
                        <el-select v-model="editForm.status" placeholder="请选择">
                            <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24" class="item">
                        <div class="label">机构简介</div>
                        <el-input v-model="editForm.description" type="textarea" :rows="3" placeholder="请输入机构简介"></el-input>
                    </el-col>
                </el-row>

            </div>

            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>

        </div>
    <BaiduMap ref="baiduMap" v-show="baiduMapShow" v-on:colseMap="baiduMapShow = false" v-on:setMap="setMap"></BaiduMap>
    </div>
</template>

<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import BaiduMap from "./BaiduMap";

    export default {
        name: 'Edit',
        data() {
            return {

                loading: false,
                baiduMapShow:false,
                uploadUrl:this.$institutionUrl+'Upload/Imgs',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),

                    name:'',
                    tel:'',
                    contacts:'',
                    address:'',
                    status:'',
                    institutionCode:'',
                    isChain:'0',
                    chainType:'',
                    lon:'',
                    lat:'',
                    logo:'',
                    description:'',
                },
                options: [{
                    value: 0,
                    label: '默认'
                    },{
                    value: 1,
                    label: '正常'
                    }, {
                    value: 2,
                    label: '禁用'
                }],
                

                chainTypes: [{
                    value: 'parent',
                    label: '总机构'
                }, {
                    value: 'middle',
                    label: '中间机构'
                }, {
                    value: 'son',
                    label: '分机构'
                }],


            }
        },
        components:{
            BaiduMap
        },
        methods: {
            init(row){
                this.editForm.name = row.name;
                this.editForm.tel = row.tel;
                this.editForm.contacts = row.contacts;
                this.editForm.address = row.address;
                this.editForm.status = row.status;
                this.editForm.institutionCode = row.institutionCode;
                this.editForm.isChain = row.isChain+'';
                this.editForm.chainType = row.chainType;
                this.editForm.lon = row.lon;
                this.editForm.lat = row.lat;
                this.editForm.logo =this.$imgUrl+ row.logo;
                this.editForm.description = row.description;
            },
            handleImgSuccess(res) {
                this.editForm.logo = this.$imgUrl+res.data.path;
            },
            openBaiduMap() {
                this.$refs.baiduMap.init();
                this.baiduMapShow = true;
            },
            setMap(info) {
                this.editForm.address = info.addressInfo
                this.editForm.lon = info.lng
                this.editForm.lat = info.lat
                this.baiduMapShow = false
            },
            closeSelf() {
                this.$emit("closeEdit");
            },

            chainTypesChange:function(selVal){
                this.editForm.chainType = selVal;
            },

            confirm(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }


                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);


                if(!this.editForm.logo){
                    this.loading = false;
                    return;
                }
                if(!this.editForm.name){
                    this.loading = false;
                    return;
                }
                if(!this.editForm.tel){
                    this.loading = false;
                    return;
                }
                if(!this.editForm.contacts){
                    this.loading = false;
                    return;
                }
                if(!this.editForm.address){
                    this.loading = false;
                    return;
                }
                if(!this.editForm.lon){
                    this.loading = false;
                    return;
                }
                if(!this.editForm.lat){
                    this.loading = false;
                    return;
                }
                console.log("sdasdasd")
                if(!this.editForm.description){
                    this.loading = false;
                    return;
                }
                if(this.editForm.isChain == 0){
                    this.editForm.chainType = 'parent';
                }

                this.editForm.logo=this.editForm.logo.replace(this.$imgUrl,'')
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Institution/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        console.log(JSON.stringify(response.data));
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else {
                            this.$message({type: 'info', message: '编辑失败'});
                        }
                    }
                )

            },


        }
    }


</script>


<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow: 2px 2px 20px 1px;
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 750px;
            /deep/ .el-input.is-disabled .el-input__inner {
                background-color: #fff;
                border-color: #DCDFE6;
                color: #606266;
                cursor: not-allowed;
            }

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y:auto;
                height: 350px;
                .avatar-uploader{ 
                    .el-upload {
                        border: 1px dashed #d9d9d9;
                        border-radius: 6px;
                        cursor: pointer;
                        position: relative;
                        overflow: hidden;
                        width:100px;
                        height: 100px;
                    }
                    .el-upload:hover {
                        border-color: #409EFF;
                    }
                }
                .avatar-uploader-icon {
                    font-size: 28px;
                    color: #8c939d;
                    width: 100px;
                    height: 100px;
                    line-height: 100px;
                    text-align: center;
                }
                .avatar {
                    width: 100%;
                    height: 100%;
                    border-radius: 6px;
                    display: block;
                }
                /deep/ .el-upload--picture-card{
                    width: 100px;
                    height: 100px;
                    line-height: 100px;
                }
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
